import { useEffect } from 'react';

let sharedObserver = null;
const callbackMap = new WeakMap();

const handleIntersections = (entries) => {
  entries.forEach((entry) => {
    const componentCallback = callbackMap.get(entry.target);
    if (componentCallback) {
      componentCallback(entry);
    }
  });
};

const useSharedObserver = (elementRef, callback) => {
  useEffect(() => {
    const element = elementRef.current;
    if (!element) {
      return;
    }

    if (!sharedObserver) {
      sharedObserver = new IntersectionObserver(handleIntersections, {
        root: null,
        threshold: 1.0
      });
    }

    callbackMap.set(element, callback);
    sharedObserver.observe(element);

    return () => {
      callbackMap.delete(element);
      if (sharedObserver) {
        sharedObserver.unobserve(element);
      }
    };
  }, [elementRef, callback]);
};

export default useSharedObserver;
